define('views/pages/account/AccountDashboardView',['underscore','jquery','views/pages/account/AccountView','app','UrlFactory','InternalLinkView',
        'template!blocks/account/dashboard', 'views/blocks/AccountOrderView', 'formatPrice'],
    function (_,$,AccountView,app,UrlFactory,InternalLinkView,dashboardTemplate, AccountOrderView) {

    //
    // Account Dashboard View
    // représente la dashboard de la page mon compte
    //

    var view;

    return AccountView.extend({

        events:{
        },

        initialize:function(){
            view = this;
            AccountView.prototype.initialize.apply(view,arguments);
            view.render();
        },

        render:function(){

               var config = app.c,
                   customer = app.getCustomer();

            this.$el.html(dashboardTemplate({
                customer:customer,
            //   ordering :customer.getOrdering(),
                loyaltyUrl: UrlFactory.getUrl('accountPage',{account_rewrite:config('_ACCOUNT_LOYALTY_REWRITE_')}),
                orderUrl: UrlFactory.getUrl('accountPage',{account_rewrite:config('_ACCOUNT_ORDERS_REWRITE_')}),
                paymentUrl: UrlFactory.getUrl('accountPage',{account_rewrite:config('_ACCOUNT_PAYMENT_REWRITE_')}),
                profileUrl: UrlFactory.getUrl('accountPage',{account_rewrite:config('_ACCOUNT_PROFILE_REWRITE_')}),
                favoriteUrl: UrlFactory.getUrl('accountPage',{account_rewrite:config('_ACCOUNT_FAVORITES_REWRITE_')}),
                logoutUrl:UrlFactory.getUrl('logout')
            }));

            customer.getOrdering().each(function (order) {

                var orderingView = new AccountOrderView({
                    order: order,
                    tracking: true,
                    target: 'ordering',
                    mode: 'light',
                    type: 'light',

                });
                view.$('.ordering').append(orderingView.el);
                view.attachView(orderingView);
                orderingView.progessOrderTest();
            });
            InternalLinkView.initializeLinksOfView(view);
        }
    });
});
